import { BritamStatisticsState } from 'Application/models';
import { fetchBritamStatistics } from 'Application/service';
import { create } from 'zustand';

export const useBritamStore = create<BritamStatisticsState>((set) => ({
    isLoading: false,
    isError: false,
    error: null,

    britamStatsData: null,

    getBritamStats: async (regionName:string) => {
        set({ isLoading: true });

        try {
            const response = await fetchBritamStatistics(regionName);
            set({ isError: false, error: null, britamStatsData: response });
        } catch (error: any) { 
            const errorMessage = error?.response?.data?.message || 'Failed to fetch Britam statistics';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isLoading: false });
        }
    }
}));
